import request from '@/utils/httpRequest'
import { encryptByAES } from '@/utils/encrypt'
/*
 * @author: xz
 * */
/*
 * @Description: 登录
 * */
export function loginToken (query) {
  return request({
    url: '/api/auth/jwt/member-token',
    method: 'POST',
    data: query
  })
}

/*
 * @Description: 获取验证码
 * */
export function getVERCode (phone, data) {
  return request({
    url: 'api/auth/jwt/' + phone + '/VERCode',
    method: 'get',
    params: data
  })
}

/*
 * @Description: 注册
 * */
export function setRegister (query) {
  return request({
    url: '/api/auth/jwt/registered',
    method: 'post',
    data: query
  })
}

/*
 * @Description: 重置密码
 * */
export function setForget (query) {
  return request({
    url: '/api/auth/jwt/reset',
    method: 'post',
    data: query
  })
}

/*
 * @Description: 我的活动报名
 * */
export function getuserappointment (memberId) {
  return request({
    url: '/api/activity/ta/' + memberId,
    method: 'get'
  })
}

/*
 * @Description: 活动报名退订
 * */
export function setappointmentunsubscribe (signUpld) {
  return request({
    url: '/api/activity/ta/unsubscribe/' + signUpld,
    method: 'put'
  })
}

/*
 * @Description: 我的场馆预订
 * */
export function getuservenue (memberId) {
  return request({
    url: '/api/onlinevenues/wt/venueScheduled/' + memberId,
    method: 'get'
  })
}

/*
 * @Description: 场馆预订退订
 * */
export function setvenueunsubscribe (scheduledId) {
  return request({
    url: '/api/onlinevenues/wt/unreg/' + scheduledId,
    method: 'put'
  })
}

/*
 * @Description: 我的收藏
 * */
export function getusercollect (data) {
  return request({
    url: '/api/personal/web/personal/collect/selectByWebUserId',
    method: 'get',
    params: data
  })
}

/*
 * @Description: 检索
 * */
export function getsearch (data) {
  return request({
    url: '/api/elasticsearch/web/home-page',
    method: 'get',
    params: data
  })
}

/*
 * *********** 积分商城 ***********
 * *********** 2020/06/28 ***********
 * */
/*
 * @Description: 获取个人积分
 * */
export function getuserpointsmall (code) {
  return request({
    url: '/api/personal/credit/web/credit/' + code,
    method: 'get'
  })
}

/*
 * @Description: 获取积分日志
 * */
export function getpointsmalcreditLog (code) {
  return request({
    url: '/api/personal/credit/web/creditLog/' + code,
    method: 'get'
  })
}

/*
 * @Description: 获取积分订单
 * */
export function getuserpointorderList (code, data) {
  return request({
    url: '/api/personal/credit/web/creditrOrder/' + code + '/page',
    method: 'get',
    params: data
  })
}

/*
 * @Description: 积分兑换
 * */
export function getuserpointcreditExchange (data) {
  return request({
    url: '/api/personal/credit/web/creditExchange',
    method: 'get',
    params: data
  })
}
/*
 * @Description: 获取积分规则列表
 * */
export function getuserpointcreditRule (code, data) {
  return request({
    url: '/api/personal/creditCommodity/web/creditRule/' + code,
    method: 'get',
    params: data
  })
}
/*
 * @Description: 获取积分使用说明
 * */
export function getuserpointcreditReadme (code) {
  return request({
    url: '/api/personal/creditCommodity/web/creditReadme/' + code,
    method: 'get'
  })
}

/*
 * @Description: 用户是否已经注册过
 * */
export function IsRegister (query) {
  return request({
    url: '/api/admin/front/group/phone-exist',
    method: 'get',
    params: query
  })
}

/*
 * @Description: 登录加密
 * */
export function loginTokenEnc (query) {
  const userMsg = encryptByAES(JSON.stringify(query))
  return request({
    url: '/api/auth/jwt/member-token-enc',
    method: 'POST',
    params: {userMsg}
  })
}

/*
 * @Description: 手机号快捷登录
 * */
export function phoneQuicklogin (query) {
  return request({
    url: '/api/auth/jwt/login-phone',
    method: 'post',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/user/index.js